var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-warp"},[_c('div',{staticClass:"main"},[_c('UserHeader',{attrs:{"username":_vm.userName,"userCode":_vm.idCard}}),_c('ExamStatus'),_c('NavigationButtons'),_c('PracticeStats'),_c('ExamStats')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }